// src/pages/Patisserie/ProductImage.jsx
import React from "react";
import { Box, Chip } from "@mui/material";

const ProductImage = ({
  image,
  displayName,
  isDiscounted = false,
  discountPercent = 0, // <- computed from price delta
  absoluteOff = 0, // optional, if you ever want "$X OFF"
}) => {
  const showBadge = isDiscounted && (discountPercent > 0 || absoluteOff > 0);
  const label =
    discountPercent > 0
      ? `${discountPercent}% OFF`
      : absoluteOff > 0
      ? `$${absoluteOff.toFixed(2)} OFF`
      : "";

  return (
    <Box sx={{ position: "relative", width: "100%", height: "100%", mb: 2 }}>
      {showBadge && (
        <Chip
          label={label}
          color="success"
          size="small"
          sx={{
            position: "absolute",
            top: 8,
            left: 8,
            zIndex: 1,
            fontWeight: 600,
          }}
        />
      )}
      <Box
        component="img"
        src={image}
        alt={displayName || ""}
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: 3,
        }}
      />
    </Box>
  );
};

export default ProductImage;
